module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "layout_section"
  }, [_c(_vm.blockTypes[_vm.sectionName], {
    tag: "component",
    attrs: {
      "cfg": _vm.config[_vm.sectionName],
      "data": _vm.dataSet[_vm.sectionName]
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464d3604","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/PageSection.vue
// module id = 9f25806934d3663a2f26
// module chunks = 0